module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Account #settingsForm":{"hooks.onPrepareValues":[{"value":function () {
fox.each(this._values, function (v, k) {
this._preparedValues[k] = fox.trim(v);
}, this);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Account #settingsForm","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/account/values.js
// module id = 710
// module chunks = 4